'use strict';

import { processInclude } from './utils/helpers';

$(document).ready(function () {
    processInclude(require('./login/login'));
    processInclude(require('./login/resetPassword'));
});
